export class VehicleType {
    id!: number;
    name!: string;
    maxQuantity!: number;
    capacityType1!: number;
    capacityType2!: number;
    capacityType3!: number;
    imgPath!:string;
    vehicleProfile!: string;
    speedFactor!:number;
}